import ApplicationStepper, {
  ApplicationStep,
} from '@/app/pages/family_application/ApplicationStepper'
import { BackIcon } from '@/common/icons/general.tsx'
import { cn } from '@/common/utilities.ts'
import { AppRoutePaths } from '@/routing/route_paths'
import { useTranslation } from 'react-i18next'
import { Outlet, useLocation, useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { RootState } from '@/storage/store'
import { useEffect } from 'react'
import { selectProgramSettings } from '@/storage/program_settings/programSettingsSlice'

type ReimbursementAccountStep = ApplicationStep & {
  field?: string
}

const ReimbursementAccountSteps: ReimbursementAccountStep[] = [
  {
    name: 'address',
    code: 'address',
    title_translation_key: 'address',
    location: AppRoutePaths.reimbursements.accounts.link.address,
    field: 'address',
  },
  {
    name: 'account_number',
    code: 'accountNumber',
    title_translation_key: 'account_number',
    location: AppRoutePaths.reimbursements.accounts.link.account_number,
    field: 'accountNumber',
  },
  {
    name: 'routing_number',
    code: 'routingNumber',
    title_translation_key: 'routing',
    location: AppRoutePaths.reimbursements.accounts.link.routing_number,
    field: 'routingNumber',
  },
  {
    name: 'bank',
    code: 'bank',
    title_translation_key: 'bank_name',
    location: AppRoutePaths.reimbursements.accounts.link.bank,
    field: 'bankName',
  },
  {
    name: 'detail',
    code: 'detail',
    title_translation_key: 'name_on_account',
    location: AppRoutePaths.reimbursements.accounts.link.detail,
    field: 'accountDetail',
  },
  {
    name: 'nickname',
    code: 'nickname',
    title_translation_key: 'nickname',
    location: AppRoutePaths.reimbursements.accounts.link.nickname,
    field: 'nickName',
  },
  {
    name: 'complete',
    code: 'complete',
    title_translation_key: 'congratulations',
    location: AppRoutePaths.reimbursements.accounts.link.complete,
    field: 'submitted',
  },
]

export const ReimbursementAccountLayout = () => {
  const { t: translate } = useTranslation()
  const navigateTo = useNavigate()
  const location = useLocation()
  const reimbursementAccountData = useSelector(
    (state: RootState) => state.ReimbursementAccount.currentAccount
  )
  const programSettings = useSelector(selectProgramSettings)
  const navigate = useNavigate()

  useEffect(() => {
    if (programSettings.reimbursement_module == 0) navigate(-1)
  }, [navigate])

  let applicationSteps: ReimbursementAccountStep[] = ReimbursementAccountSteps

  const currentStepIndex = applicationSteps.findIndex((step) =>
    location.pathname.includes(step.name)
  )

  const getNestedValue = (obj: any, path: string) => {
    return path
      .split('.')
      .reduce((acc, key) => (acc ? acc[key] : undefined), obj)
  }

  const completedSteps = applicationSteps
    .filter((step) => {
      const value = getNestedValue(reimbursementAccountData, step.field ?? '')
      if (Array.isArray(value)) {
        return value.length > 0
      }
      return Boolean(value)
    })
    .map((step) => step.code)

  return (
    <>
      <div className={cn('flex-grow flex flex-col')}>
        {currentStepIndex != undefined && (
          <div className="flex items-center mb-4 lg:mb-8">
            <button
              type="button"
              onClick={() => navigateTo(-1)}
              aria-label={translate('back')}
            >
              <BackIcon className="w-6 h-6" />
            </button>
            <ApplicationStepper
              completeSteps={completedSteps}
              currentStepIndex={currentStepIndex}
              steps={applicationSteps}
              className={cn('grow flex justify-center')}
            />
            <div></div>
          </div>
        )}

        <div className={cn('flex-grow flex flex-col max-w-xl w-full mx-auto')}>
          <Outlet />
        </div>
      </div>
    </>
  )
}
